import React, { Component } from "react";
import PropTypes from "prop-types";
import Console from "../../util/Console";

class ParentHistoryComponent extends Component {
	constructor() {
		super();
	}

	componentDidMount() {
		const parentPath = this.props.location.state ? this.props.location.state.param : "";
		if (window.parent) {
			try {
				if (!parentPath) {
					window.top.history.back();
				}
				else {
					window.top.location.href = '/' + parentPath;
				}
			}
			catch (exception) {
				Console.warn("Not in Iframe, no valid top window: " + exception);
			}
		}
		else {
			Console.warn("Not in Iframe, no parent window.");
		}
	}

	render() {
		return null;
	}
}

ParentHistoryComponent.propTypes = {
	parentPath: PropTypes.string,
	location: PropTypes.object
};

export default ParentHistoryComponent;
